import React, { memo } from 'react';
import classNames from 'classnames';
import cls from './NestingTabs.module.css';
import { CustomTooltip } from '../../../../../../components/UI/CustomTooltip/CustomTooltip';
import { useDispatch, useSelector } from 'react-redux';
import { gantActions } from '../../../../store/reducers/gantSlice/gantSlice';
import { stageSelector } from '../../../../store/reducers/stageSlice/stageSlice';
import { charterSelector } from '../../../../store/reducers/charterSlice/charterSlice';

export const NestingTabs = memo(() => {
    const { nestingTabs } = useSelector((state) => state.gantReducer);
    const stages = useSelector(stageSelector.selectAll);
    const chartersEntities = useSelector(charterSelector.selectEntities);

    const dispatch = useDispatch();
    const onNestingTabs = (value) => {
        dispatch(gantActions.changeNestingTabs(value));
        let initIsOpenStage = {};
        let initIsOpenCharter = {};

        if (value === 'stages') {
            initIsOpenStage = {};
            initIsOpenCharter = {};
        }
        if (value === 'charters') {
            stages.forEach((stage) => {
                initIsOpenStage[stage.id] = true;
            });
        }
        if (value === 'all') {
            stages.forEach((stage) => {
                initIsOpenStage[stage.id] = true;
                stage.positions.forEach((charterGuid) => {
                    if (!!chartersEntities[charterGuid]) {
                        initIsOpenCharter[charterGuid] = true;
                    }
                });
            });
        }
        dispatch(gantActions.changeOpenStage(initIsOpenStage));
        dispatch(gantActions.changeOpenCharters(initIsOpenCharter));
    };

    return (
        <div className={classNames(cls.NestingTabs)}>
            <CustomTooltip
                title={i18next.t('NestingTabs.return.CustomTooltip.title')}
                position={'top-start'}
            >
                <div
                    className={classNames(cls.tabItem, cls.stages, {
                        [cls.active]: nestingTabs === 'stages',
                    })}
                    onClick={() => onNestingTabs('stages')}
                >
                    <svg
                        width="24"
                        height="14"
                        viewBox="0 0 24 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <g clipPath="url(#clip0_2746_33212)">
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M0 12V2V1.75C0 0.783501 0.89543 0 2 0H4C4.79781 0 5.48654 0.408763 5.80753 1H24V13H5.80753C5.48653 13.5912 4.79781 14 4 14H2C0.89543 14 0 13.2165 0 12.25V12Z"
                                fill={`${nestingTabs === 'stages' ? 'white' : '#A4A5B5'}`}
                            />
                        </g>
                        <defs>
                            <clipPath id="clip0_2746_33212">
                                <rect width="24" height="14" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
            </CustomTooltip>
            <CustomTooltip
                title={i18next.t('NestingTabs.return.CustomTooltip.charters.title')}
                position={'top'}
            >
                <div
                    className={classNames(cls.tabItem, cls.charters, {
                        [cls.active]: nestingTabs === 'charters',
                    })}
                    onClick={() => onNestingTabs('charters')}
                >
                    <svg
                        width="24"
                        height="14"
                        viewBox="0 0 24 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <g clipPath="url(#clip0_2746_33218)">
                            <mask
                                id="mask0_2746_33218"
                                // style="mask-type:luminance"
                                maskUnits="userSpaceOnUse"
                                x="0"
                                y="0"
                                width="24"
                                height="14"
                            >
                                <path d="M23.8125 0H0V14H23.8125V0Z" fill="white" />
                            </mask>
                            <g mask="url(#mask0_2746_33218)">
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M0 6.00001V6.125C0 6.60824 0.391751 7 0.875 7H1.75C2.09904 7 2.40036 6.79562 2.54079 6.5H23.8125V0.5H2.54079C2.40036 0.204382 2.09904 0 1.75 0H0.875C0.391751 0 0 0.391751 0 0.875V1V6.00001Z"
                                    fill={`${nestingTabs === 'charters' ? 'white' : '#A4A5B5'}`}
                                />
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M4 13.2857V13.375C4 13.7202 4.27982 14 4.625 14H5.25C5.55236 14 5.80459 13.7853 5.8625 13.5H23.8125V9.5H5.8625C5.80459 9.21472 5.55236 9 5.25 9H4.625C4.27982 9 4 9.27982 4 9.625V9.71429V13.2857Z"
                                    fill={`${nestingTabs === 'charters' ? 'white' : '#A4A5B5'}`}
                                />
                            </g>
                        </g>
                        <defs>
                            <clipPath id="clip0_2746_33218">
                                <rect width="24" height="14" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
            </CustomTooltip>
            <CustomTooltip
                title={i18next.t('NestingTabs.return.CustomTooltip.all.title')}
                position={'top'}
            >
                <div
                    className={classNames(cls.tabItem, cls.all, {
                        [cls.active]: nestingTabs === 'all',
                    })}
                    data-hint-target="schedule-expand-all"
                    onClick={() => onNestingTabs('all')}
                >
                    <svg
                        width="24"
                        height="16"
                        viewBox="0 0 24 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <g clipPath="url(#clip0_2746_33239)">
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M0 4.78572V4.875C0 5.22017 0.279822 5.5 0.625 5.5H1.25C1.55236 5.5 1.80459 5.28528 1.8625 5H23.8125V1H1.8625C1.80459 0.71472 1.55236 0.5 1.25 0.5H0.625C0.279822 0.5 0 0.779822 0 1.125V1.21429V4.78572Z"
                                fill={`${nestingTabs === 'all' ? 'white' : '#A4A5B5'}`}
                            />
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M5 10.9286V11C5 11.2761 5.22386 11.5 5.5 11.5H6C6.27614 11.5 6.5 11.2761 6.5 11H23.8125V8H6.5C6.5 7.72386 6.27614 7.5 6 7.5H5.5C5.22386 7.5 5 7.72386 5 8V8.07143V10.9286Z"
                                fill={`${nestingTabs === 'all' ? 'white' : '#A4A5B5'}`}
                            />
                            <path
                                d="M23.8125 13.5H8.8125C8.26022 13.5 7.8125 13.9477 7.8125 14.5C7.8125 15.0523 8.26022 15.5 8.8125 15.5H23.8125V13.5Z"
                                fill={`${nestingTabs === 'all' ? 'white' : '#A4A5B5'}`}
                            />
                        </g>
                        <defs>
                            <clipPath id="clip0_2746_33239">
                                <rect
                                    width="24"
                                    height="15"
                                    fill="white"
                                    transform="translate(0 0.5)"
                                />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
            </CustomTooltip>
        </div>
    );
});
